import { useEffect } from "react";
import { Link } from "wouter";
import { SEO } from "@/components/SEO";
import { SiteLayout } from "@/components/layout/SiteLayout";

const HUBS = [
  { href: "/perspectives", label: "Perspectives" },
  { href: "/books", label: "Books" },
  { href: "/projects", label: "Projects" },
  { href: "/media", label: "Media" },
  { href: "/speaking", label: "Speaking" },
  { href: "/founder-of-the-shrink-network", label: "The Shrink Network" },
  { href: "/faq", label: "FAQ" },
  { href: "/verified", label: "Verify Dr. Refai" },
];

const FEATURED = [
  {
    href: "/perspectives/why-thinking-harder-usually-makes-anxiety-worse",
    label: "Why Thinking Harder Usually Makes Anxiety Worse",
  },
  {
    href: "/perspectives/what-modern-psychiatry-gets-right",
    label: "What Modern Psychiatry Gets Right",
  },
  {
    href: "/perspectives/why-your-mind-feels-loudest-when-trying-to-rest",
    label: "Why Your Mind Feels Loudest When You're Trying to Rest",
  },
  { href: "/books/your-mind-is-full-of-shit", label: "Your Mind Is Full of Sh*t" },
];

export default function NotFound() {
  useEffect(() => {
    // Client-side 404 (SPA navigation to an unknown path). The static
    // public/404.html fires the same event for direct hits.
    window.gtag?.("event", "page_not_found", { page_path: window.location.pathname });
  }, []);

  return (
    <SiteLayout>
      <SEO
        title="Page Not Found | Shariq Refai, MD, MBA"
        description="The page you're looking for isn't on shariqrefai.com. Search the site, head back to the homepage, or start from one of the sections listed on this page."
        noindex
      />
      <section className="py-20 md:py-28 px-4 md:px-8">
        <div className="container mx-auto max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-accent">Page not found</p>
          <h1 className="mt-4 text-4xl md:text-5xl font-serif text-primary leading-tight">
            This page isn't on shariqrefai.com.
          </h1>
          <p className="mt-6 text-lg text-secondary font-light max-w-2xl">
            The link may be old or the address may be mistyped. Everything on
            this site is still reachable from the sections below.
          </p>
          <form
            role="search"
            action="https://www.google.com/search"
            method="get"
            className="mt-8 flex gap-2 max-w-lg"
          >
            <input type="hidden" name="as_sitesearch" value="shariqrefai.com" />
            <label htmlFor="nf-q" className="sr-only">
              Search shariqrefai.com
            </label>
            <input
              id="nf-q"
              name="q"
              type="search"
              placeholder="Search this site"
              className="flex-1 h-12 px-4 border border-border bg-white text-primary"
            />
            <button type="submit" className="h-12 px-5 bg-primary text-primary-foreground text-sm font-medium">
              Search
            </button>
          </form>
          <h2 className="mt-12 text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground">
            Head somewhere specific
          </h2>
          <ul className="mt-4 grid sm:grid-cols-2 gap-3 list-none p-0">
            {HUBS.map((h) => (
              <li key={h.href}>
                <Link href={h.href} className="text-primary font-medium hover:text-accent">
                  {h.label}
                </Link>
              </li>
            ))}
          </ul>
          <h2 className="mt-12 text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground">
            Readers often start here
          </h2>
          <ul className="mt-4 space-y-3 list-none p-0">
            {FEATURED.map((f) => (
              <li key={f.href}>
                <Link href={f.href} className="text-primary font-medium hover:text-accent">
                  {f.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </SiteLayout>
  );
}
